/*
 * The console's two languages, as naloge-api spells them (docs/API.md → Enums, Locale). A
 * person's language (`Me.locale`) sets the console after signing in, and the e-mails they get
 * are written in it.
 */
export enum Locale {
    Sl = 'sl',
    En = 'en',
}

export const LOCALES: Locale[] = [Locale.Sl, Locale.En]

export const DEFAULT_LOCALE = Locale.Sl

/** The BCP 47 tag Intl and the `lang` attribute are given for each language. */
export const INTL_LOCALE: Record<Locale, string> = {
    [Locale.Sl]: 'sl-SI',
    [Locale.En]: 'en-GB',
}
